import { render } from "./PcHomeView.vue?vue&type=template&id=05c3aeca&scoped=true"
import script from "./PcHomeView.vue?vue&type=script&lang=js"
export * from "./PcHomeView.vue?vue&type=script&lang=js"

import "./PcHomeView.vue?vue&type=style&index=0&id=05c3aeca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c3aeca"]])

export default __exports__